import http from '@/utils/request.js'

export const login = (params) => {
  return http.request({
    url: '/login',
    headers:{
      isToken: false,
      repeatSubmit: false,
    },
    method: 'POST',
    data: params
  })
}

export const getCodeImg = ()=> {
  return http.request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'GET',
    timeout: 20000
  })
}

export const loginOut = ()=>{
  return http.request({
    url: '/logout',
    method: 'POST',
  })
}
